// Shared constants + helpers for the Mission Control admin components.
// Keep this small — no JSX exports here, pure utilities only.

export const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export const RED = "#FF2A3C";
export const NEON = "#42FFB0";
export const AMBER = "#FFB400";
export const PURPLE = "#7C5CFF";

export const fmt$ = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

export const ago = (iso) => {
  if (!iso) return "—";
  const s = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
};

// Lead age color coding for the "We Call You In 30 Minutes" promise.
//   Green  (< 30min)   → FRESH
//   Yellow (30m–4h)    → WARM
//   Red    (> 4h)      → STALE
export function leadAge(iso) {
  if (!iso) return { color: "#6B7280", label: "—", minutes: 0, text: "—" };
  const minutes = (Date.now() - new Date(iso).getTime()) / 60000;
  let color = NEON;
  let label = "FRESH";
  if (minutes >= 240) { color = RED; label = "STALE"; }
  else if (minutes >= 30) { color = AMBER; label = "WARM"; }
  let text;
  if (minutes < 1) text = "<1m";
  else if (minutes < 60) text = `${Math.round(minutes)}m`;
  else if (minutes < 1440) text = `${(minutes / 60).toFixed(1)}h`;
  else text = `${Math.round(minutes / 1440)}d`;
  return { color, label, minutes, text };
}

export function authHeader(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function fetchJSON(path, token) {
  return fetch(`${API}${path}`, { headers: authHeader(token) })
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null);
}
